import { type FC } from 'react';
import { useNavigate } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';

const Footer: FC = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-10">
        <Reveal className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Logo & description */}
            <div className="text-center md:text-left">
              <a
                href="/"
                onClick={(e) => { e.preventDefault(); navigate('/'); }}
                className="inline-flex items-center gap-2 mb-2 cursor-pointer"
              >
                <div className="w-7 h-7 rounded-full bg-secondary-500 flex items-center justify-center">
                  <i className="ri-flask-line text-white text-xs"></i>
                </div>
                <span className="font-heading text-lg font-bold">
                  <span className="text-primary-700">Lotto</span><span className="text-secondary-600">Lab</span>
                </span>
              </a>
              <p className="text-foreground-500 text-xs">
                행운을 실험하다, LottoLab
              </p>
            </div>

            {/* Links */}
            <div className="flex flex-wrap items-center justify-center gap-6">
              <a
                href="/"
                onClick={(e) => { e.preventDefault(); navigate('/'); }}
                className="text-foreground-500 hover:text-foreground-800 text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                번호 생성
              </a>
              <a
                href="/guide"
                onClick={(e) => { e.preventDefault(); navigate('/guide'); }}
                className="text-foreground-500 hover:text-foreground-800 text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                이용방법
              </a>
              <a
                href="/statistics"
                onClick={(e) => { e.preventDefault(); navigate('/statistics'); }}
                className="text-foreground-500 hover:text-foreground-800 text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                통계 분석
              </a>
              <a
                href="/my-numbers"
                onClick={(e) => { e.preventDefault(); navigate('/my-numbers'); }}
                className="text-foreground-500 hover:text-foreground-800 text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                내 번호
              </a>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-xs">
              &copy; {currentYear} LottoLab. All rights reserved.
            </p>
            <p className="text-foreground-500 text-xs">
              본 서비스는 참고용이며, 실제 당첨을 보장하지 않습니다.
            </p>
          </div>
        </Reveal>
      </div>
    </footer>
  );
};

export default Footer;